<template>
  <div
    class="card mediaCard p-4 clickable"
    :class="{ large: item.isFeatured }"
  >
    <div @click="openLink(item.id)">
      <div class="card--img">
        <div
          class="featured-wrapper"
        >
          <div
            v-if="item.isFeatured"
            class="featured-ribbon has-next-tag"
          >
            Featured
          </div>
          <div
            class="featured-ribbon category"
            :class="categoryClass"
          >
            {{ item?.category?.join('') }}
          </div>
        </div>
        <img
          class="blog-image"
          :src="getMediaImage(item) ?? ''"
          alt="Media Image"
        >
      </div>
      <div>
        <div class="mb-0">
          <strong class="is-brightGreen">{{ item.postedBy }}</strong> on {{ item.postDate && new Date(item.postDate).toLocaleDateString("en-US", { month: 'short', day: 'numeric', year: 'numeric' }) }}
        </div>
        <div
          class="title"
          :class="{h3: item.isFeatured, h5: !item.isFeatured}"
        >
          {{ item.title }}
        </div>

        <template v-if="item.pageDescription != null">
          <div
            v-sane-html="highlightText(searchText, item.pageDescription)"
            class="text-ellipsis mt-4"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MediaItemType } from '@/composables/state/mediaSearchApp';
import { highlightText, openLink } from '@/config/common';

import { PropType, computed } from 'vue';

const props = defineProps({
  item: { type: Object as PropType<MediaItemType>, default: () => { return {}; } },
  defaultImageUrl: { type: String, default: '' },
  childPageUrl: { type: String, default: '' },
  searchText: { type: String as PropType<string | null>, default: '' },
  isListMode: { type: Boolean, default: false },
  defaultImageUrls: { type: Object as PropType<Record<string, string>>, default: null },
});

// const searchAuthor = (author:string) => {
//   window.location.href =
//         window.location.protocol + '//' +
//         window.location.host +
//         window.location.pathname +
//         '?author=' + author;
// };

const categoryClass = computed(() => {
  if (!props.item?.category) return '';
  const category = props.item.category.join('').replace(/\s+/g, '-').toLowerCase(); // Replace spaces with dashes and make lowercase
  return `category-${category}`;
});

const WEB_HOME_URL = import.meta.env.VITE_APP_HOME_URL ?? '';

const getMediaImage = (item: MediaItemType) => {
  if (item.imagePath != null && item.imagePath.length > 0) { // when no image provided, use default placeholder image
    return `${WEB_HOME_URL}/.imaging/mte/abmi-theme/max-400/dam${item.imagePath}`;
  }
  if (item.category != null) {
    const category = item.category[0].toLowerCase().replace(' ', '_');
    return `${WEB_HOME_URL}${props.defaultImageUrls[category] ?? props.defaultImageUrls.default ?? ''}`;
  }
  return null;
};

</script>

<style scoped>
.title {
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;

  height: 3.3rem;
  line-height: 1.6rem;
  margin-bottom: 0.5rem;
}
.description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.pub-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  min-height:250px;
  background-position: center;
}
.text-ellipsis{
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.category-in-the-news {
  background-color: #9764A0 !important;
}
.category-video{
  background-color: #856A38 !important;
}
.category-news{
  background-color: #704E48 !important;
}
.category-event{
  background-color: #9B2C2C !important;
}
.category-webinar {
  background-color: #717665 !important;
}
.card--img .featured-wrapper .featured-ribbon.has-next-tag {
  border-radius: 0px;
}
</style>
